import {gql} from "@apollo/client";
    
export const CREATE_PROJECTS = gql`  
mutation CreateProject($input: CreateProjectInput!) {
  createProject(input: $input) {
    id
    name
    description
    createdAt
    updatedAt
    createdById
    updatedById
    createdByName
    updatedByName
  }
}`;

export const CREATE_VENDOR_PROJECT_USER = gql`
  mutation CreateVendorProjectUser($input: CreateVendorProjectUserInput!) {
    createVendorProjectUser(input: $input) {
      message
    }
  }
`;

export const CREATE_STUDENT_SESSION_ALLOCATIONS = gql`
  mutation CreateSessionAllocations($input: CreateSessionAllocationsInput!) {
  createSessionAllocations(input: $input) {
    message
  }
}
`;


export const CREATE_NLEARN3_LIVECLASS_PACKAGES = gql`
  mutation CreateNlearn3LiveclassPackages(
    $input: CreateNlearn3LiveclassPackageInput!
  ) {
    createNlearn3LiveclassPackages(input: $input) {
      package {
        id
        name
        batchId
        batchName
        classId
        className
        collegeId
        collegeName
        sectionId
        sectionName
        academicYearId
        academicYearName
        streamId
        streamName
        createdAt
        updatedAt
        createdById
        updatedById
        createdByName
        updatedByName
      }
    }
  }
`;

export const CREATE_NLEARN3_PACKAGE_SCHEDULE = gql`
  mutation CreateNlearn3PackageSchedule(
    $input: CreateNlearn3PackageScheduleInput!
  ) {
    createNlearn3PackageSchedule(input: $input) {
      id
      liveSessionId
      status
      scheduledDurationInMin
      scheduledParticipantsCount
      meetingTitle
      meetingSubTitle
      thumbnailUrl
      notesUrl
      recordingMetadata
      cancelledAt
      completedAt
      isActive
      createdAt
      updatedAt
      createdById
      updatedById
      createdByName
      updatedByName
    }
  }
`;

export const CREATE_HOST_JOINING_LINK = gql`
  mutation CreateJoiningLink($input: ZoomSdkConfigInput!) {
    createJoiningLink(input: $input) {
      hostJoiningLink
    }
  }
`;

export const CREATE_NLEARN3_PACKAGE_SCHEDULE_CO_HOST = gql`
  mutation CreateNlearn3PackageScheduleCoHost($input: [CreateNlearn3PackageScheduleCohostInput!]!) {
    createNlearn3PackageScheduleCoHost(input: $input) {
      message
    }
  }
`;

export const CREATE_NLEARN3_PACKAGE_SCHEDULE_OBSERVER = gql`
  mutation CreateNlearn3PackageScheduleObserver($input: [CreateNlearn3PackageScheduleObserverInput!]!) {
    createNlearn3PackageScheduleObserver(input: $input) {
      message
    }
  }
`;

export const UPDATE_NLEARN3_LIVECLASS_MASTER = gql`
  mutation UpdateNlearn3LiveclassMaster($input: UpdateNlearn3LiveClassMasterInput!) {
    updateNlearn3LiveclassMaster(input: $input) {
      nlearn3LiveClassMaster {
        id
        class
        liveClassUrl
        recordedUrls
        thumbnail
        urlSource
        name
        duration
        liveDateTime
        courseDay
        batch
        subBatch
        college
        admissionNumber
        markAsDeleted
        liveClassId
        subjectName
        subject
        employee
        branch
        department
        designation
        recordedVideoMaxVisibleDate
        packageId
        packageName
        yearId
        createdAt
        updatedAt
      }
    }
  }
`;